'use client';

import React from 'react';
import AppSidebar from './AppSidebar';
import AppTopbar from './AppTopbar';

interface AppLayoutProps {
  children: React.ReactNode;
  breadcrumb?: { label: string; href?: string }[];
}

export default function AppLayout({ children, breadcrumb }: AppLayoutProps) {
  return (
    <div className="pn-appraisal__layout">
      <AppSidebar />
      <div className="pn-appraisal__main">
        <AppTopbar breadcrumb={breadcrumb} />
        {children}
      </div>
    </div>
  );
}